import { LoginPage } from './../login/login';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { User } from '../../providers';
import { TranslateService } from '@ngx-translate/core';
import { TestPage } from '../test/test';
import { ResultadosPage } from '../resultados/resultados';
import { StepsPage } from '../steps/steps';
import { WelcomePage } from '../welcome/welcome';

/**
 * Generated class for the FirstPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface MyObj {
  id: string;
  userId: number;
  user : {
    name: string;
    lastname: string;
    age: string;
    teststatus: number;
    answered: string;
    email: string;
  }
}

interface Count {
  lastname: string,
  teststatus: number,
  answered: number
}

@IonicPage()
@Component({
  selector: 'page-first',
  templateUrl: 'first.html',
})

export class FirstPage {

  private loginErrorString: string;

  ComenzarTest = false;
  ContinuaTest = false;
  ResultadosTest = false;
  state: string;
  emailreturn: string;

  user_info: any;

  obj: MyObj;

  count2: Count;

  constructor(public navCtrl: NavController, public navParams: NavParams, public user: User, public translateService: TranslateService, public alertCtrl: AlertController, public toastCtrl: ToastController) {
    //this.user_info = user.getUser();
    //console.log("User Logged: "+ JSON.stringify(this.navParams.get("user")));

    this.emailreturn = '';

    try {
      this.user_info =  this.navParams.get("user");
      console.log("get user from params: "+ JSON.stringify(this.navParams.get("user")));

      var us:MyObj;
      us = {
        id: "123",
        userId: 22,
        user: {
          name: "hector polanco",
          teststatus: 1,
          lastname: "",
          age: "",
          answered: "0",
          email: "hector19polanco@gmail.com"
        }
      };

      if(JSON.stringify(this.navParams.get("user")) == undefined) {
        console.log("undefined");
        this.obj = us;
        this.navCtrl.push(WelcomePage,{});
      } else {
        console.log("not undefined");
        this.obj = JSON.parse(JSON.stringify(this.user_info));
        console.log(this.obj.id);
        console.log(this.obj.userId);
        console.log(this.obj.user.name);
        console.log(this.obj.user.teststatus);
      }
    } catch(err) {
      this.navCtrl.push(LoginPage,{});
    }



    if(this.obj.user.teststatus == 0) {
      this.state = "Inicia tu test ahora!";
      this.ComenzarTest = true;
    } else if(this.obj.user.teststatus == 1) {
      this.state = "Debes continuar con tu test, !Continúa ahora!";
      this.ContinuaTest = true;
    } else if(this.obj.user.teststatus == 2) {
      this.state = "Ya has realizado tu test. ¡Puedes ver tus resultados ahora!";
      this.ResultadosTest = true;
    } else {
      this.state = "otro status";
    }

    console.log("user_info: "+  this.obj);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FirstPage');
    //console.log('user: ' + JSON.stringify(this.navParams.get("user")));
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter');
    console.log('user: ' + JSON.stringify(this.navParams.get("user")));
    //this.obj.user.email = JSON.stringify(this.navParams.get('mail'));
  }
  ionViewWillLeave() {
    console.log('ionViewWillLeave');
  }
  ionViewDidLeave() {
    console.log('ionViewDidLeave');
  }
  ionViewWillUnload() {
    console.log('ionViewWillUnload');
    try {
      console.log('user: ' + JSON.stringify(this.navParams.get("user").user.email));
      this.emailreturn = JSON.parse(JSON.stringify(this.navParams.get("user").user.email));
    } catch(e) {
      console.log('exception: ' + e);
    }
  }

  getAnswererCount() {

    var url = "accounts/getAnsweredCount?access_token=".concat(this.obj.id).concat("&data=").concat("{\"id\":\""+this.obj.userId+"\"}");

      this.user.getAnsweredCount(url, {}).subscribe((resp) => {
        console.log("Ok: status: "+resp);
        console.log("Ok: data: "+ JSON.stringify(resp)); // data received by server

        console.log(""+resp['data']);
        console.log(""+JSON.stringify(resp['data']));

        console.log(""+resp['data']['teststatus']);
        console.log(""+JSON.stringify(resp['data']['answered']));

        this.obj.user.teststatus = resp['data']['teststatus'];
        this.obj.user.answered = resp['data']['answered'];

        this.doTest();
      }, (err) => {
        console.log("Ok: status: "+err);
        console.log("Ok: data: "+ JSON.stringify(err)); // data received by server
        //console.log("Ok: headers: "+resp.headers);
        //this.showAlert("Ok: "+JSON.stringify(err), "Resp: "+err);
        //this.navCtrl.push(MainPage);
        // Unable to log in
        this.showAlert("Error",""+JSON.stringify(err));
        let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
        });
        toast.present();
      });
  }

  showAlert(tit: string, msj: string) {
    const alert = this.alertCtrl.create({
      title: tit,
      subTitle: msj,
      buttons: ['Aceptar']
    });
    alert.present();
  }

  doTest() {
    console.log("doTest;");
    console.log("status: "+this.obj.user.teststatus);
    if(this.obj.user.teststatus == 0) {

      var url = "accounts/update?where={\"_id\":\"".concat(""+this.obj.userId).concat("\"}&access_token=").concat(this.obj.id);

      this.user.upgradeStatus(url, { "teststatus": 1 }).subscribe((resp) => {
        console.log("Ok: status: "+resp);
        console.log("Ok: data: "+ JSON.stringify(resp)); // data received by server
        //console.log("Ok: headers: "+resp.headers);
        //this.showAlert("Ok: "+JSON.stringify(resp), "Resp: "+resp);
        this.navCtrl.push(StepsPage,
          {
            user: this.obj.userId,
            answered: this.obj.user.answered,
            token: this.obj.id
          });
        //this.doTest();
      }, (err) => {
        console.log("Ok: status: "+err);
        console.log("Ok: data: "+ JSON.stringify(err)); // data received by server
        //console.log("Ok: headers: "+resp.headers);
        //this.showAlert("Ok: "+JSON.stringify(err), "Resp: "+err);
        //this.navCtrl.push(MainPage);
        // Unable to log in
        this.showAlert("Error",""+JSON.stringify(err));
        let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
        });
        toast.present();
      });

    } else if(this.obj.user.teststatus == 1) {

      this.navCtrl.push(TestPage,
        {
          user: this.obj.userId,
          answered: this.obj.user.answered,
          token: this.obj.id
        });

    } else if(this.obj.user.teststatus == 2) {
      this.navCtrl.push(ResultadosPage);
      //this.router.navigate(['resultados']);
    } else {
      this.state = "otro status";
    }
  }

  getResults() {
    this.navCtrl.push(ResultadosPage,
      {
        user: this.obj.userId,
        mail: this.obj.user.email,
        token: this.obj.id,
        from_test: false
      });
  }

  logout() {
    this.navCtrl.setRoot(WelcomePage,
      {
        user : {
          userId: '',
          id: '',
          user: {
            name: '',
            teststatus: ''
          }
        }
      });
    this.navCtrl.popToRoot();
  }

}



// WEBPACK FOOTER //
// ./src/pages/first/first.ts